import { useQuery } from 'react-query';
import { TSearchScheduledOrdersBody, TSearchScheduledOrdersResponse } from '@dekafvv/sharedfrontend';
import type {
    TGetContactGroupsById,
} from './types';
import {
    getContactGroupsById, postSearchScheduledOrders, preliminaryKeyForgotPassword,
} from './requests';

export const useGetContactGroupsById = ({
    contactGroupId,
    refetchOnMount = true,
    enabled = true,
    onSuccess,
    onError,
}: {
    contactGroupId: string;
    refetchOnMount?: boolean,
    enabled?: boolean
    onSuccess?: (resp: any) => void,
    onError?: () => void,
}) => {
    const query = useQuery<
        TGetContactGroupsById,
        null | { message: string },
        TGetContactGroupsById
    >({
        queryFn: () => getContactGroupsById({ contactGroupId }).then(({ data }) => data),
        queryKey: [
            'getContactGroupsById',
            contactGroupId,
        ],
        refetchOnWindowFocus: false,
        refetchOnMount,
        enabled,
        onSuccess: (resp) => {
            if (onSuccess) {
                onSuccess(resp);
            }
        },
        onError: () => {
            if (onError) {
                onError();
            }
        },
    });

    return query;
};

export const useGetPreliminaryKeyForgotPassword = ({
    body,
    onSuccess,
    onError,
    enabled,
    refetchOnMount = true,
}: {
    body: { email: string, username: string },
    refetchOnMount?: boolean;
    enabled?: boolean;
    onSuccess?: (generatedSessionId: string) => void,
    onError?: (err: any) => void,
}) => useQuery({
    queryFn: () => preliminaryKeyForgotPassword(body).then(({ data }) => data),
    onSuccess: (resp) => {
        if (onSuccess) {
            onSuccess(resp.GeneratedSessionId as string);
        }
    },
    refetchOnWindowFocus: false,
    refetchOnMount,
    enabled,
    onError: (err) => {
        if (onError) {
            onError(err);
        }
    },
});

export const useSearchScheduledOrders = ({
    contactGroupId,
    contactId,
    body,
    enabled,
    refetchOnMount = true,
    onError,
    onSuccess,
}: {
    contactGroupId: string | number,
    contactId: string | number,
    body: TSearchScheduledOrdersBody,
    onSuccess?: (resp: any) => void,
    onError?: () => void,
    enabled?: boolean,
    refetchOnMount?: boolean,
}) => {
    const query = useQuery<TSearchScheduledOrdersResponse, any, TSearchScheduledOrdersResponse>({
        queryFn: () => postSearchScheduledOrders({
            contactGroupId,
            contactId,
            body,
        }).then(({ data }) => data),
        queryKey: [
            'searchScheduledOrders',
            contactGroupId,
            contactId,
            body,
        ],
        refetchOnWindowFocus: false,
        refetchOnMount,
        enabled,
        onSuccess: (resp) => {
            if (onSuccess) {
                onSuccess(resp);
            }
        },
        onError: () => {
            if (onError) {
                onError();
            }
        },
    });

    return query;
};
